import React, { createContext, useContext, useEffect, useState } from "react";

import en from "./locales/en.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import hi from "./locales/hi.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import sr from "./locales/sr.json";
import tr from "./locales/tr.json";
import zh from "./locales/zh.json";

export const LANGS = [
  "en", "ar", "de", "es", "fr", "hi", "it",
  "ja", "ko", "pt", "ru", "sr", "tr", "zh",
];

const RESOURCES = { en, ar, de, es, fr, hi, it, ja, ko, pt, ru, sr, tr, zh };
const STORAGE_KEY = "zilouet_lang";

const I18nContext = createContext(null);

function detectInitialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && RESOURCES[saved]) return saved;
  } catch (e) {
    /* storage unavailable */
  }
  try {
    const nav = (navigator.language || "en").split("-")[0].toLowerCase();
    if (RESOURCES[nav]) return nav;
  } catch (e) {
    /* navigator unavailable */
  }
  return "en";
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* storage unavailable */
    }
    document.documentElement.lang = lang;
    // Layout stays identical to English for every language; only the text
    // changes (bidi handles right-to-left script). Never flip dir/layout.
    document.documentElement.dir = "ltr";
  }, [lang]);

  const t = (key) => {
    const table = RESOURCES[lang] || en;
    const value = table[key];
    if (value !== undefined && value !== null && value !== "") return value;
    const fallback = en[key];
    return fallback !== undefined ? fallback : key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside <I18nProvider>");
  return ctx;
}
